import { render } from "./DependentDisclosure.vue?vue&type=template&id=769d0425&scoped=true"
import script from "./DependentDisclosure.vue?vue&type=script&lang=js"
export * from "./DependentDisclosure.vue?vue&type=script&lang=js"

import "./DependentDisclosure.vue?vue&type=style&index=0&id=769d0425&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769d0425"]])

export default __exports__